// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2yym6","containerItemsCenter":"Skeleton_containerItemsCenter__3skX3"};